import { Button } from '@servicetitan/design-system';

export interface BookButtonProps {
    onClick: () => void;
    /** Pending state between click and show()/picker-open; unset by default. */
    disabled?: boolean;
    /** Pending state between click and show()/picker-open; unset by default. */
    loading?: boolean;
    /**
     * Header variant for non-sidebar viewports (CPO-4572): x-small, neutral
     * outline so it sits on one 44px row with the menu button and avatar.
     */
    compact?: boolean;
}

export const BookButton = ({ compact = false, disabled, loading, onClick }: BookButtonProps) => {
    return (
        <Button
            fill="outline"
            size={compact ? 'xsmall' : 'small'}
            iconName="event"
            primary={!compact}
            onClick={onClick}
            disabled={disabled}
            loading={loading}
            data-testid="book-us-button"
        >
            Book Us
        </Button>
    );
};
